import { useEffect, useRef } from 'react';
/**
 * Lorem ipsum
 * @param initialValue boolean
 * @returns ref
 * @see Overlay Table
 */

export default function useMounted() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var isMountedRef = useRef(initialValue);
  useEffect(function () {
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
}
//# sourceMappingURL=useMounted.js.map